import { EventTypeGroup } from './EventTypeGroup';
import { EventType } from './EventType';
import { EventTypeProcessInstance } from './EventTypeProcessInstance';

export class EventTypeProcess {
    constructor(
        eventTypeGroup: EventTypeGroup,
        eventType: EventType | null,
        sequenceNr: number | null,
        isConcurrent: boolean,
        isMandatory: boolean,
        evTypePrcInstanceList: EventTypeProcessInstance[],
        evTypePrcList: EventTypeProcess[],
        isExpandable: boolean,
        isSelectable: boolean,
        allSeqFinished: boolean,
        isExpanded: boolean,
        isSelected: boolean,
        displayName: string
    ) {
        this.eventTypeGroup = eventTypeGroup;
        this.eventType = eventType;
        this.sequenceNr = sequenceNr;
        this.isConcurrent = isConcurrent;
        this.isMandatory = isMandatory;
        this.evTypePrcInstanceList = evTypePrcInstanceList;
        this.evTypePrcList = evTypePrcList;
        this.isExpandable = isExpandable;
        this.isSelectable = isSelectable;
        this.allSeqFinished = allSeqFinished;
        this.isExpanded = isExpanded;
        this.isSelected = isSelected;
        this.displayName = displayName;
    }
    eventTypeGroup: EventTypeGroup;
    eventType: EventType | null;
    sequenceNr: number | null;
    isConcurrent: boolean;
    isMandatory: boolean;
    evTypePrcInstanceList: EventTypeProcessInstance[];
    evTypePrcList: EventTypeProcess[];
    isExpandable: boolean;
    isSelectable: boolean;
    allSeqFinished: boolean;
    isExpanded: boolean;
    isSelected: boolean;
    displayName: string;
}
